import { useLocation, useNavigate } from "react-router-dom";
import mainStore from "../../store/store";
import React, { useEffect, useState } from "react";
const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setSelectedRoute } = mainStore();
  const currentPath = location.pathname.replace(/\/+$/, "") || "/";

  useEffect(() => {
    setSelectedRoute(currentPath);
  }, [currentPath, setSelectedRoute]);

  const isActiveRoute = (route) => {
    if (route === "/") {
      return currentPath === "/";
    }

    if (route === "/blog") {
      return currentPath === "/blog" || currentPath.startsWith("/blog/");
    }

    if (route === "/carslist") {
      return currentPath.startsWith("/car-rental/") || [
        "/cars",
        "/carslist",
        "/car-details",
        "/booking",
        "/rental-form",
        "/extras",
        "/payment",
      ].includes(currentPath);
    }

    return currentPath === route;
  };

  const routeTo = (routeTo) => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    
    navigate(routeTo);
    setSelectedRoute(routeTo);
  };
  const [showPopup, setShowPopup] = useState(false);
  return (
    <>
      <header class="Header">

        <div class="container">
          <img
            className="cursor-pointer"
            src="/img/logo.png"
            alt="TAK8 Car Rental Logo"
            onClick={() => routeTo("/")}
          />
          <ul class="DesktopMenu cursor-pointer">
            <li>
              <a
                onClick={() => routeTo("/")}
                class={`${isActiveRoute("/") ? "active" : ""}`}
              >
                Home
              </a>
            </li>
            <li>
              <a
                onClick={() => routeTo("/services")}
                class={`${isActiveRoute("/services") ? "active" : ""}`}
              >
                Our Services
              </a>
            </li>
            <li>
              <a
                onClick={() => routeTo("/carslist")}
                class={`${isActiveRoute("/carslist") ? "active" : ""}`}
              >
                Cars
              </a>
            </li>
            {/* <li>
              <a
                onClick={() => routeTo("/truck-utes")}
                class={`${selectedRoute === "/truck-utes" ? "active" : ""}`}
              >
                Trucks & Utes
              </a>
            </li> */}
            <li>
              <a
                onClick={() => routeTo("/blog")}
                class={`${isActiveRoute("/blog") ? "active" : ""}`}
              >
                Blog
              </a>
            </li>
            <li>
              <a
                onClick={() => routeTo("/about-us")}
                class={`${isActiveRoute("/about-us") ? "active" : ""}`}
              >
                About Us
              </a>
            </li>
            <li>
              <a
                onClick={() => routeTo("/contact-us")}
                class={`${isActiveRoute("/contact-us") ? "active" : ""}`}
              >
                Contact Us
              </a>
            </li>
          </ul>
          <ul class="MobileMenu">
            <li>
              <a
                onClick={() => routeTo("/")}
                class={`${isActiveRoute("/") ? "active" : ""}`}
              >
                <svg width="20" height="20" viewBox="0 0 20 20">
                  <path d="M3.3335 17.5V7.5L10.0002 2.5L16.6668 7.5V17.5H11.6668V11.6667H8.3335V17.5H3.3335Z" />
                </svg>

                <span>Home</span>
              </a>
            </li>
            <li>
              <a
                onClick={() => routeTo("/services")}
                class={`${isActiveRoute("/services") ? "active" : ""}`}
              >
                <svg width="20" height="20" viewBox="0 0 20 20">
                  <path d="M7.70833 18.3333L7.375 15.6667C7.19445 15.5972 7.02431 15.5139 6.86458 15.4167C6.70486 15.3194 6.54861 15.2153 6.39583 15.1042L3.91667 16.1458L1.625 12.1875L3.77083 10.5625C3.75694 10.4653 3.75 10.3715 3.75 10.2812V9.71874C3.75 9.62846 3.75694 9.53471 3.77083 9.43749L1.625 7.81249L3.91667 3.85416L6.39583 4.89582C6.54861 4.78471 6.70833 4.68054 6.875 4.58332C7.04167 4.4861 7.20833 4.40277 7.375 4.33332L7.70833 1.66666H12.2917L12.625 4.33332C12.8056 4.40277 12.9757 4.4861 13.1354 4.58332C13.2951 4.68054 13.4514 4.78471 13.6042 4.89582L16.0833 3.85416L18.375 7.81249L16.2292 9.43749C16.2431 9.53471 16.25 9.62846 16.25 9.71874V10.2812C16.25 10.3715 16.2361 10.4653 16.2083 10.5625L18.3542 12.1875L16.0625 16.1458L13.6042 15.1042C13.4514 15.2153 13.2917 15.3194 13.125 15.4167C12.9583 15.5139 12.7917 15.5972 12.625 15.6667L12.2917 18.3333H7.70833ZM10.0417 12.9167C10.8472 12.9167 11.5347 12.6319 12.1042 12.0625C12.6736 11.493 12.9583 10.8055 12.9583 9.99999C12.9583 9.19443 12.6736 8.50693 12.1042 7.93749C11.5347 7.36804 10.8472 7.08332 10.0417 7.08332C9.22222 7.08332 8.53125 7.36804 7.96875 7.93749C7.40625 8.50693 7.125 9.19443 7.125 9.99999C7.125 10.8055 7.40625 11.493 7.96875 12.0625C8.53125 12.6319 9.22222 12.9167 10.0417 12.9167Z" />
                </svg>
                <span>Services</span>
              </a>
            </li>
            <li>
              <a
                onClick={() => routeTo("/carslist")}
                class={`${isActiveRoute("/carslist") ? "active" : ""}`}
              >
                <svg width="20" height="20" viewBox="0 0 20 20">
                  <path d="M5 15.8333V16.6667C5 16.9028 4.92014 17.1007 4.76042 17.2604C4.60069 17.4201 4.40278 17.5 4.16667 17.5H3.33333C3.09722 17.5 2.89931 17.4201 2.73958 17.2604C2.57986 17.1007 2.5 16.9028 2.5 16.6667V9.99999L4.25 4.99999C4.33333 4.74999 4.48264 4.5486 4.69792 4.39582C4.91319 4.24305 5.15278 4.16666 5.41667 4.16666H14.5833C14.8472 4.16666 15.0868 4.24305 15.3021 4.39582C15.5174 4.5486 15.6667 4.74999 15.75 4.99999L17.5 9.99999V16.6667C17.5 16.9028 17.4201 17.1007 17.2604 17.2604C17.1007 17.4201 16.9028 17.5 16.6667 17.5H15.8333C15.5972 17.5 15.3993 17.4201 15.2396 17.2604C15.0799 17.1007 15 16.9028 15 16.6667V15.8333H5ZM4.83333 8.33332H15.1667L14.2917 5.83332H5.70833L4.83333 8.33332ZM6.25 13.3333C6.59722 13.3333 6.89236 13.2118 7.13542 12.9687C7.37847 12.7257 7.5 12.4305 7.5 12.0833C7.5 11.7361 7.37847 11.441 7.13542 11.1979C6.89236 10.9549 6.59722 10.8333 6.25 10.8333C5.90278 10.8333 5.60764 10.9549 5.36458 11.1979C5.12153 11.441 5 11.7361 5 12.0833C5 12.4305 5.12153 12.7257 5.36458 12.9687C5.60764 13.2118 5.90278 13.3333 6.25 13.3333ZM13.75 13.3333C14.0972 13.3333 14.3924 13.2118 14.6354 12.9687C14.8785 12.7257 15 12.4305 15 12.0833C15 11.7361 14.8785 11.441 14.6354 11.1979C14.3924 10.9549 14.0972 10.8333 13.75 10.8333C13.4028 10.8333 13.1076 10.9549 12.8646 11.1979C12.6215 11.441 12.5 11.7361 12.5 12.0833C12.5 12.4305 12.6215 12.7257 12.8646 12.9687C13.1076 13.2118 13.4028 13.3333 13.75 13.3333Z" />
                </svg>
                <span>Cars</span>
              </a>
            </li>
            {/* <li>
              <a
                onClick={() => routeTo("/truck-utes")}
                class={`${selectedRoute === "/truck-utes" ? "active" : ""}`}
              >
                <svg width="21" height="20" viewBox="0 0 21 20">
                  <path d="M5.50016 16.6667C4.80572 16.6667 4.21544 16.4236 3.72933 15.9375C3.24322 15.4514 3.00016 14.8611 3.00016 14.1667H1.3335V5.00001C1.3335 4.54168 1.49669 4.14932 1.82308 3.82293C2.14947 3.49654 2.54183 3.33334 3.00016 3.33334H14.6668V6.66668H17.1668L19.6668 10V14.1667H18.0002C18.0002 14.8611 17.7571 15.4514 17.271 15.9375C16.7849 16.4236 16.1946 16.6667 15.5002 16.6667C14.8057 16.6667 14.2154 16.4236 13.7293 15.9375C13.2432 15.4514 13.0002 14.8611 13.0002 14.1667H8.00016C8.00016 14.8611 7.75711 15.4514 7.271 15.9375C6.78489 16.4236 6.19461 16.6667 5.50016 16.6667ZM5.50016 15C5.73627 15 5.93419 14.9201 6.09391 14.7604C6.25364 14.6007 6.3335 14.4028 6.3335 14.1667C6.3335 13.9306 6.25364 13.7326 6.09391 13.5729C5.93419 13.4132 5.73627 13.3333 5.50016 13.3333C5.26405 13.3333 5.06614 13.4132 4.90641 13.5729C4.74669 13.7326 4.66683 13.9306 4.66683 14.1667C4.66683 14.4028 4.74669 14.6007 4.90641 14.7604C5.06614 14.9201 5.26405 15 5.50016 15ZM15.5002 15C15.7363 15 15.9342 14.9201 16.0939 14.7604C16.2536 14.6007 16.3335 14.4028 16.3335 14.1667C16.3335 13.9306 16.2536 13.7326 16.0939 13.5729C15.9342 13.4132 15.7363 13.3333 15.5002 13.3333C15.2641 13.3333 15.0661 13.4132 14.9064 13.5729C14.7467 13.7326 14.6668 13.9306 14.6668 14.1667C14.6668 14.4028 14.7467 14.6007 14.9064 14.7604C15.0661 14.9201 15.2641 15 15.5002 15ZM14.6668 10.8333H18.2085L16.3335 8.33334H14.6668V10.8333Z" />
                </svg>
                <span> Trucks & Utes</span>
              </a>
            </li> */}
            <li>
              <a
                onClick={() => routeTo("/blog")}
                class={`${isActiveRoute("/blog") ? "active" : ""}`}
              >
                <svg width="20" height="20" viewBox="0 0 20 20">
                  <path d="M3.33333 2.5C2.89583 2.5 2.53125 2.65625 2.23958 2.96875C1.94792 3.28125 1.79167 3.64583 1.79167 4.08333V15.9167C1.79167 16.3542 1.94792 16.7188 2.23958 17.0313C2.53125 17.3438 2.89583 17.5 3.33333 17.5H16.6667C17.1042 17.5 17.4688 17.3438 17.7604 17.0313C18.0521 16.7188 18.2083 16.3542 18.2083 15.9167V4.08333C18.2083 3.64583 18.0521 3.28125 17.7604 2.96875C17.4688 2.65625 17.1042 2.5 16.6667 2.5H3.33333ZM3.33333 4.16667H16.6667V7.5H3.33333V4.16667ZM3.33333 9.16667H8.33333V15.8333H3.33333V9.16667ZM10 9.16667H16.6667V15.8333H10V9.16667Z"/>
                </svg>
                <span>Blog</span>
              </a>
            </li>
            <li>
              <a
                onClick={() => routeTo("/about-us")}
                class={`${isActiveRoute("/about-us") ? "active" : ""}`}
              >
                <svg width="20" height="20" viewBox="0 0 20 20">
                  <path d="M4.87484 14.25C5.58317 13.7083 6.37484 13.2812 7.24984 12.9687C8.12484 12.6562 9.0415 12.5 9.99984 12.5C10.9582 12.5 11.8748 12.6562 12.7498 12.9687C13.6248 13.2812 14.4165 13.7083 15.1248 14.25C15.6109 13.6805 15.9894 13.0347 16.2603 12.3125C16.5311 11.5903 16.6665 10.8194 16.6665 9.99999C16.6665 8.15277 16.0172 6.57985 14.7186 5.28124C13.42 3.98263 11.8471 3.33332 9.99984 3.33332C8.15261 3.33332 6.5797 3.98263 5.28109 5.28124C3.98248 6.57985 3.33317 8.15277 3.33317 9.99999C3.33317 10.8194 3.46859 11.5903 3.73942 12.3125C4.01025 13.0347 4.38873 13.6805 4.87484 14.25ZM9.99984 10.8333C9.18039 10.8333 8.48942 10.5521 7.92692 9.98957C7.36442 9.42707 7.08317 8.7361 7.08317 7.91666C7.08317 7.09721 7.36442 6.40624 7.92692 5.84374C8.48942 5.28124 9.18039 4.99999 9.99984 4.99999C10.8193 4.99999 11.5103 5.28124 12.0728 5.84374C12.6353 6.40624 12.9165 7.09721 12.9165 7.91666C12.9165 8.7361 12.6353 9.42707 12.0728 9.98957C11.5103 10.5521 10.8193 10.8333 9.99984 10.8333ZM9.99984 18.3333C8.84706 18.3333 7.76373 18.1146 6.74984 17.6771C5.73595 17.2396 4.854 16.6458 4.104 15.8958C3.354 15.1458 2.76025 14.2639 2.32275 13.25C1.88525 12.2361 1.6665 11.1528 1.6665 9.99999C1.6665 8.84721 1.88525 7.76388 2.32275 6.74999C2.76025 5.7361 3.354 4.85416 4.104 4.10416C4.854 3.35416 5.73595 2.76041 6.74984 2.32291C7.76373 1.88541 8.84706 1.66666 9.99984 1.66666C11.1526 1.66666 12.2359 1.88541 13.2498 2.32291C14.2637 2.76041 15.1457 3.35416 15.8957 4.10416C16.6457 4.85416 17.2394 5.7361 17.6769 6.74999C18.1144 7.76388 18.3332 8.84721 18.3332 9.99999C18.3332 11.1528 18.1144 12.2361 17.6769 13.25C17.2394 14.2639 16.6457 15.1458 15.8957 15.8958C15.1457 16.6458 14.2637 17.2396 13.2498 17.6771C12.2359 18.1146 11.1526 18.3333 9.99984 18.3333Z" />
                </svg>
                <span>About</span>
              </a>
            </li>
            <li>
              <a
                onClick={() => routeTo("/contact-us")}
                class={`${isActiveRoute("/contact-us") ? "active" : ""}`}
              >
                <svg width="20" height="20" viewBox="0 0 20 20">
                  <path d="M9.1665 17.5V15.8333H15.8332V9.91667C15.8332 8.29167 15.2672 6.91319 14.1353 5.78125C13.0033 4.64931 11.6248 4.08333 9.99984 4.08333C8.37484 4.08333 6.99636 4.64931 5.86442 5.78125C4.73248 6.91319 4.1665 8.29167 4.1665 9.91667V15H3.33317C2.87484 15 2.48248 14.8368 2.15609 14.5104C1.8297 14.184 1.6665 13.7917 1.6665 13.3333V11.6667C1.6665 11.375 1.73942 11.1007 1.88525 10.8438C2.03109 10.5868 2.23595 10.3819 2.49984 10.2292L2.56234 9.125C2.67345 8.18056 2.94775 7.30556 3.38525 6.5C3.82275 5.69444 4.37136 4.99306 5.03109 4.39583C5.69081 3.79861 6.44775 3.33333 7.30192 3C8.15609 2.66667 9.05539 2.5 9.99984 2.5C10.9443 2.5 11.8401 2.66667 12.6873 3C13.5346 3.33333 14.2915 3.79514 14.9582 4.38542C15.6248 4.97569 16.1734 5.67361 16.604 6.47917C17.0346 7.28472 17.3123 8.15972 17.4373 9.10417L17.4998 10.1875C17.7637 10.3125 17.9686 10.5 18.1144 10.75C18.2603 11 18.3332 11.2639 18.3332 11.5417V13.4583C18.3332 13.7361 18.2603 14 18.1144 14.25C17.9686 14.5 17.7637 14.6875 17.4998 14.8125V15.8333C17.4998 16.2917 17.3366 16.684 17.0103 17.0104C16.6839 17.3368 16.2915 17.5 15.8332 17.5H9.1665ZM7.49984 11.6667C7.26373 11.6667 7.06581 11.5868 6.90609 11.4271C6.74636 11.2674 6.6665 11.0694 6.6665 10.8333C6.6665 10.5972 6.74636 10.3993 6.90609 10.2396C7.06581 10.0799 7.26373 10 7.49984 10C7.73595 10 7.93386 10.0799 8.09359 10.2396C8.25331 10.3993 8.33317 10.5972 8.33317 10.8333C8.33317 11.0694 8.25331 11.2674 8.09359 11.4271C7.93386 11.5868 7.73595 11.6667 7.49984 11.6667ZM12.4998 11.6667C12.2637 11.6667 12.0658 11.5868 11.9061 11.4271C11.7464 11.2674 11.6665 11.0694 11.6665 10.8333C11.6665 10.5972 11.7464 10.3993 11.9061 10.2396C12.0658 10.0799 12.2637 10 12.4998 10C12.7359 10 12.9339 10.0799 13.0936 10.2396C13.2533 10.3993 13.3332 10.5972 13.3332 10.8333C13.3332 11.0694 13.2533 11.2674 13.0936 11.4271C12.9339 11.5868 12.7359 11.6667 12.4998 11.6667ZM5.02067 10.375C4.92345 8.90278 5.36789 7.63889 6.354 6.58333C7.34011 5.52778 8.56928 5 10.0415 5C11.2776 5 12.3644 5.39236 13.3019 6.17708C14.2394 6.96181 14.8054 7.96528 14.9998 9.1875C13.7359 9.17361 12.5728 8.83333 11.5103 8.16667C10.4478 7.5 9.63178 6.59722 9.06234 5.45833C8.84011 6.56944 8.37136 7.55903 7.65609 8.42708C6.94081 9.29514 6.06234 9.94444 5.02067 10.375Z" />
                </svg>
                <span>Contact</span>
              </a>
            </li>
          </ul>
        </div>
      </header>
    </>
  );
};

export default Header;
